module.exports = __webpack_public_path__ + "52fcafb60809ece2da20fd26b0b0047a.pdf";